<template lang="pug">
  section.section.main-content
    .o-container
        header.headline
          h1(class="title").headline__title Nueva Cotización
        .select-form
            form(v-on:submit.prevent, ref="formNew")
                .c-form
                    .c-form__form-row.c-form__form-row--full
                        header.headline
                          div(class="phrase-wrapper")
                            span Ingresa 
                            span(class="phrase") la información necesaria(*)
                            span para cotizar
                    .c-form__form-row.c-form__form-row--full(v-if="executive")
                        label(class="c-form__form-label") Broker
                        select(id="broker", class="select" name="broker", v-model="quotation.broker", required)
                            option(
                              :value="broker.id"
                              v-for="broker in brokers"
                            ) {{broker.full_name}}
                    .c-form__form-row.c-form__form-row--full
                        label(class="c-form__form-label") ¿Es un consorcio o grupo de empresa?
                        toggle-button(
                          :value="quotation.partnership",
                          color="#24cdc4",
                          :labels="{checked: 'SI', unchecked: 'NO'}",
                          @input="handleToggle"
                        )
                    .c-form__form-row
                        label(for="contractor", class="c-form__form-label") CONTRATANTE (*)
                        input(id="contractor",
                          name="contractor",
                          type="text",
                          @input="handleInput"
                          :value="quotation.contractor",
                          class="c-form__form-input",
                          required
                        )
                        label(class="error-label") {{errors.contractor}}
                    .c-form__form-row
                        label(for="ruc", class="c-form__form-label") RUC/DNI&nbsp;
                            span(v-if="!!!quotation.partnership") (*)
                        input(id="ruc",
                          name="ruc",
                          type="text",
                          @input="handleInput"
                          :value="quotation.ruc",
                          class="c-form__form-input",
                          :required="!!!quotation.partnership"
                        )
                        label(class="error-label") {{errors.ruc}}
                    .c-form__form-row
                      label(for="turn", class="c-form__form-label") GIRO (*)
                      div(class="quotation-giro-wrapper")
                        img(class="quotation-giro-icon-search" src="../assets/images/icon-search.svg")
                        b-autocomplete(
                          ref="autocomplete"
                          placeholder="Busca un giro"
                          class="autocomplete-new-quotation"
                          @select="option => quotation.turn = option"
                          v-model="quotation.newturn"
                          :data="filteredDataObj"
                          field="name"
                          @input="turnValidate"
                          @blur="turnValidateKey"
                          :open-on-focus="true"
                          required
                        )
                          template(#footer)
                            div(v-if='!hideQuotationGiro')
                              a(v-if='errorQuotationGiro && errorQuotationGiroAlfNum' @click="quotationTurnAdd")
                                span  Otro
                          template(#empty) No se encontraron resultados {{quotation.newturn}}
                            div.quotation-giro-error-alfnum(v-if='!errorQuotationGiroAlfNum') Debes ingresar un giro válido
                      .quotation-giro-error(v-if='errorQuotationGiro.status') {{ errorQuotationGiro.message }}
                      .quotation-giro-error(v-if='errorQuotationGiroModal.status') {{ errorQuotationGiroModal.message }} 
                    .c-form__form-row
                        label(for="activity", class="c-form__form-label") DETALLE DE ACTIVIDAD&nbsp;
                            span(v-if="!fieldsValids.activity") (*)
                        input(id="activity",
                          name="activity",
                          type="text",
                          @input="handleInput"
                          :value="quotation.activity",
                          class="c-form__form-input"
                          ref="act"
                        )
                        label(class="error-label") {{errors.activity}}
                    .comment-wrapper
                        label(class="c-form__form-label") COMENTARIOS
                        textarea.c-form__form-input.c-form__form-input--textarea(
                          @input="handleInput"
                          :value="quotation.comment"
                          name="comment",
                          id="comment",
                          placeholder="Escribe una nota o comentario"
                        )
                        label(class="error-label") {{errors.comment}}
                    .c-form__form-row.c-form__form-row--full
                        label(class="c-form__form-label") PRODUCTO / PROGRAMA A COTIZAR
                        ul.product-list(:class="{ 'product-list__empty': quotation.products.length < 1 }")
                            li(v-for="product in quotation.products")
                                .product-element
                                    .product-element-cell.product-name {{ product.name }}
                                    .product-element-cell.product-files-count {{ getTotalFiles(product.fields) }} archivos adjuntos
                                    .product-element-cell.product-action
                                        .product-action-element
                                .product-detail
                                    .product-detail-row
                                        .product-detail-cell(v-for="field in product.fields" v-if="field.field_type != 'file'")
                                            p.heading {{ field.name }}
                                            p.value {{ parseFieldValue(field) }}
                                    .product-detail-row
                                        .product-detail-cell(v-for="field in product.fields" v-if="field.field_type == 'file' && field.value != undefined")
                                            p.heading {{ field.name }}
                                            a.document(v-if="field.filename" :href="field.value.url", target="_blank", :title="field.filename") {{ showFileName(field.filename) }}
                        div.product-buttons-wrapper
                          button.product-button( @click.prevent="handleProductButton(product.name)", :key="product.id", class="button-product", :class="{'is-active': addStyle(product.name) }",  v-for="product in productsList" v-if="product.name !== productsName.programaEstrategicoCopy") {{product.name}}
                        form-products(
                          :products="formProductsToShow"
                          @deleteFormProduct="handleProductButton"
                          @handleInputProduct="validateForm"
                        )
                    .c-form__form-btn
                        button.button-primary__lineal(@click="onCancel") Cancelar
                        button.button-primary__solid(type="submit", @click.prevent="onSubmit" :disabled="disabledSubmit || multifileIsLoading") {{createLabel}}
                    .c-form__form-row.c-form__form-row--full.tyc
                        span Al crear la cotización en la plataforma de La Positiva aceptas las Políticas de usos.
        modal-error-service(@close="closeModal")
  </template>
  
  <script>
  import CommentBox from '@/components/AppCommentBox.vue';
  import AppCommentsViewer from '@/components/AppCommentsViewer.vue';
  import ModalErrorService from '../views/modals/ErrorService.vue';
  import FormProducts from '../components/FormProducts.vue';
  
  import SiteConfig from '@/services/positiva.js';
  import { createQuotation, getGroupedProducts, updateProductData } from '@/services/services.js';
  import { getBrokerList } from '../services/User/broker';
  import { getBussinessTurn } from '../services/Commons';
  import { isBroker, isExecutive } from '@/mixins/user.js';
  
  import store from '@/store'
  import { getTechnicalList } from '../services/User/technical';
  
  const MULTIRIESGO = "Multiriesgo"
  const SOAT = "SOAT"
  const VEHICULAR = "Vehicular"
  const PROGRAMA_ESTRATEGICO = "Programa estratégico (Multiriesgo/RC/3D)"
  const PROGRAMA_ESTRATEGICO_COPY = "Programa estratégico (Multiriesgo/RC/3D)COPY"
  const BOLSA_RESP_3D_DESH_ROBO = "Responsabilidad Civil, Deshonestidad, 3D y Robo"
  const BOLSA_MULTI_INC = "Multiriesgo e Incendio"
  const BOLSA_SOATVEH = "SOAT y Vehiculares"
  
  export default {
      components: {
        CommentBox,
        AppCommentsViewer,
        ModalErrorService,
        FormProducts
      },
      data () {
        return {
          productsCharged: false,
          selectedProduct: {},
          createRequestIsLoading: false,
          brokers: [],
          businessTurnList: [],
          fieldsValids: {
            contractor: false,
            ruc: false,
            activity: true,
            comment: true,
            products: false,
            turn: false
          },
          errors: {
            contractor:"",
            ruc:"",
            comment: "",
            activity: "",
            turn: "",
          },
          rucEvent: null,
          activityEvent: {
            target: {}
          },
          quotation: {
            id: 10,
            contractor: '',
            partnership: false,
            ruc: '',
            description: '',
            products: [],
            broker: null,
            turn: null,
            activity: '',
            comment: "",
            newturn: ''
          },
          turnSelected: null,
          businessTurnName: '',
          disabledSubmit: true,
          productsName: {
            programaEstrategicoCopy: "Programa estratégico (Multiriesgo/RC/3D)COPY",
          },
          productsList: [],
          activeProductButton: {
            "3D":false,
            "Accidentes Personales":false,
            "Asistencia Médica (Grupal o corporativo)":false,
            "CAR":false,
            "Deshonestidad":false,
            "EAR":false,
            "Equipo Electrónico":false,
            "Flota":false,
            "Multiriesgo":false,
            "Responsabilidad Civil":false,
            "Robo y Asalto":false,
            "SOAT":false,
            "TREC":false,
            "Transporte":false,
          },
          formProductsToShow: [],
          turnNameSelected: "1",
          errorQuotationGiro: {
            status: false,
            message: ''
          },
          errorQuotationGiroModal: {
            status: false,
            message: ''
          },
          hideQuotationGiro: false,
          errorQuotationGiroAlfNum: false,
          idOtros: '',
          activityRequired: true,
          soatStatus : false,
          technical_asig: null,
          idSoatVehicular: null,
          technicalStrategicList: [],
          idProgramaEstrategico: null,
          idProgramaEstrategicoCopy: null,
          tid: null,
          programaEstrategicoVuex: null,
          idTemporaly: 1000,
          idBagResp3dDeshRobo: null,
          idBagResp3dDeshRoboTechnical: null,
          idBagMultiInc: null,
          idBagMultiIncTechnical: null,
          
        }
      },
      mounted () {
        
        this.$store.commit('setIdTemporaly', 1000);
        getGroupedProducts().then(product =>{
          product.data[0].products.forEach((prod)=>{
            if(prod.name === PROGRAMA_ESTRATEGICO){
              this.idProgramaEstrategico= prod.id
              this.$store.commit('setTid', prod.id);
            }
            if(prod.name === PROGRAMA_ESTRATEGICO_COPY){
              this.idProgramaEstrategicoCopy= prod.id
              this.$store.commit('setProgramaEstrategicoVuex', prod.id);
            }
          })
        })

        getTechnicalList('bags/').then(list =>{
          list.data.forEach( bag =>{
            if(bag.name === BOLSA_SOATVEH){
              this.idSoatVehicular = bag.id
            }
          })
          getTechnicalList(`operative/direct-assignees/?team_bag__in=${this.idSoatVehicular}`).then((result) => {
            this.technicalStrategicList = result.data
            store.commit('setTechList', this.technicalStrategicList)
          })
        })

        /** Bolsas - Obtener los ID's de los tecnicos para programa estrategico**/
        getTechnicalList('bags/').then(list =>{
          list.data.forEach(bag =>{
            if(bag.name === BOLSA_RESP_3D_DESH_ROBO){
              this.idBagResp3dDeshRobo = bag.id
            }
            if(bag.name === BOLSA_MULTI_INC){
              this.idBagMultiInc = bag.id
            }
          })
          getTechnicalList(`operative/direct-assignees/?team_bag__in=${this.idBagResp3dDeshRobo}`).then((result) => {
            let bagOneTechnicalList = result.data.map(team => team.superior_id)
            this.idBagResp3dDeshRoboTechnical = bagOneTechnicalList[0]
          })
          getTechnicalList(`operative/direct-assignees/?team_bag__in=${this.idBagMultiInc}`).then((result) => {
            let bagTwoTechnicalList = result.data.map(team => team.superior_id)
            this.idBagMultiIncTechnical = bagTwoTechnicalList[0]
          })
        })
        /** **/
        
        getBussinessTurn().then((result) => {
          this.businessTurnList = result.data
          this.businessTurnList.forEach(busines=>{
            if(busines.name==="OTROS"){
              this.idOtros= busines.id
            }
          })
        });
        if(isExecutive()) {
          getBrokerList().then( response =>{
            this.brokers = response.data;
            this.quotation.broker = this.brokers[0].id
          })
        }
        getGroupedProducts().then((response) => {
          if (response.status == 200) {
            this.productsList = response.data[0].products
            // const arrayProductToShow = []
            this.productsList.forEach( product => {
              product["isValid"] = false
              product.fields.forEach( field => {
                field["isValid"] = true
                if (field.required === true) {
                  field.isValid = false
                }
                if(field.field_type === 'money') {
                  field["currency"] = 'S/'
                }
              })
            })
            response.data[0].products.map( product => {
              this.activeProductButton[product.name] = false
            })
            }
          }).catch((error) => {
              console.log(error)
          });
      },
      computed: {
        filteredDataObj() {
          let idHide= this.idOtros
          return this.businessTurnList.filter((option) => {
            if(option.id !== idHide)
              return option.name
                  .toString()
                  .toLowerCase()
                  .indexOf(this.quotation.newturn.toLowerCase()) >= 0
          })
        },
        createLabel() {
          return isBroker() ? 'Enviar' : 'Crear'; 
        },
        executive() {
          return isExecutive();
        },
        multifileIsLoading() {
          return store.state.fileCommentIsLoading
        }
      },
      
      methods: {
        
        turnValidateKey(){
          if(this.quotation.turn === null){
            this.errorQuotationGiro.status = true
            this.errorQuotationGiro.message = "Debes seleccionar un giro o registrar uno nuevo"
            this.fieldsValids.turn = data
          }
          else{
            this.errorQuotationGiro.status = false
            this.fieldsValids.turn = true
          }
          this.validateForm() 
        },
        turnValidate(value) {
          let RegexAlfanumeric = /[^0-9a-zA-Z ]/;
          let selectGiro = this.filteredDataObj.some( giro => giro['name'] === value.toUpperCase())

          //Validacion de alfanumericos y maximo 50 caracteres
          if(value.match(RegexAlfanumeric) || value.length > 50){
              this.errorQuotationGiroAlfNum = false
          }else{
            this.errorQuotationGiroAlfNum = true
          }

          //si existe el giro se deshabilita el boton de otro
          if(selectGiro){
            this.hideQuotationGiro = true
          }
          else{
            this.hideQuotationGiro = false
          }
                    
          //Validacion para escocger un giro de la lista o crear otro
          if(this.quotation.turn === null || this.quotation.newturn.trim() === ""){
            this.errorQuotationGiro.status = true
            this.errorQuotationGiro.message = "Debes seleccionar un giro o registrar uno nuevo"
            this.fieldsValids.turn = false
          }
          else{
            this.errorQuotationGiro.status = false
            this.fieldsValids.turn = true
          }
         
          this.validateForm() 
                   
        },
        quotationTurnAdd() {
          this.$buefy.dialog.prompt({
              message: `GIRO`,
              inputAttrs: {
                  placeholder: 'Ingresa un giro',
                  value: this.quotation.newturn,
                  required: true,
                  maxlength: 50,
                  pattern: "[A-Za-z0-9 ]+"
              },
              confirmText: 'Aceptar',
              cancelText: 'Cancelar',
              onConfirm: (value) => {
                let selValue = this.businessTurnList.some( giro => giro['name'] === value.toUpperCase())
                if (value.trim() === "") {
                  this.$buefy.toast.open({
                    message: 'Debes ingresar un giro válido',
                    duration: 4000,
                    type: 'is-danger',
                  }),
                  this.quotation.newturn = ""
                  return false
                }
                else if(selValue){
                  this.$buefy.toast.open({
                    message: 'El giro ingresado ya existe',
                    duration: 4000,
                    type: 'is-danger',
                  }),
                  this.quotation.newturn = value
                  return false
                }
                else{
                  this.quotation.description = value
                  this.$refs.autocomplete.setSelected(value)
                  this.errorQuotationGiro.status = false
                  this.fieldsValids.turn = true
                  this.validateForm()
                }
            },
          })
        },
        onCancel() {
          this.$router.push('/dashboard')
        },
        closeModal() {
        this.$modal.hide('modal-error-service');
        },
        handleToggle(value) {
          this.quotation.partnership = value
          value ? this.errors.ruc = "" : null
          this.rucValidations(this.rucEvent)
          this.validateForm()
        },
        handleInput(e) {
          this.quotation[e.target.name] = e.target.value
          e.target.name === "contractor"? this.contractorValidations(e): null
          if(e.target.name === "ruc"){
            this.rucValidations(e)
            this.rucEvent = e
          }
          e.target.name === "activity"? this.activityValidations(e): null
          e.target.name === "comment"? this.commentVAlidations(e): null
          this.validateForm()
        },
  
        contractorValidations(e) {
          this.fieldsValids.contractor = this.inputRequired(e) && this.maxCharacters(e, 100)
        },
  
        rucValidations(e) {
          if (this.quotation.partnership) {
            this.errors.ruc = ""
            this.fieldsValids.ruc = this.maxCharacters(e, 11)
          }else {
            this.fieldsValids.ruc = this.inputRequired(e) && this.maxCharacters(e, 11)
          }
        },
  
        activityValidations(e = {target: {name: "activity"}}) {
          this.fieldsValids.activity = this.maxCharacters(e, 200) 
          this.formProductsToShow.forEach( product => {
            if (product.name === MULTIRIESGO){

              this.fieldsValids.activity = this.inputRequired(e) && this.maxCharacters(e, 200)
              //this.activityRequired = true
              return true
            }
          })
        },
  
        commentVAlidations(e) {
          this.fieldsValids.comment = this.maxCharacters(e, 1000)
        },
  
        maxCharacters(e, max) {
          if(this.quotation[e.target.name].length > max) {
            this.errors[e.target.name] = `máximo ${max} caracteres`
            return false
          }else {
            this.errors[e.target.name] = ""
            return true
          }
        },
  
        inputRequired(e) {
          if(this.quotation[e.target.name].length == 0) {
            this.errors[e.target.name] = "Este campo es requerido"
            return false
          }else {
            this.errors[e.target.name] = ""
            return true
          }
        },
  
        validateProducts() {
          const productsValids = []
          const formProductsCharged = store.state.formsProducts
          if(this.formProductsToShow.length >= 1) {
            formProductsCharged.forEach( formProduct => {
              const someIsInvalid = formProduct.fields.some(field => field.isValid === false)
              productsValids.push(!someIsInvalid)
            })
            const someProductFormIsInvalid = productsValids.some(productValid => productValid === false)
            if ( someProductFormIsInvalid ) {
                this.fieldsValids.products = false
              } else {
                this.fieldsValids.products = true
              }
          } else {
            this.fieldsValids.products = false
          }
        },
  
        validateForm() {
          this.validateProducts()
          let fieldsIsValids = Object.values(this.fieldsValids)
          for(let i=0; i< fieldsIsValids.length; i++){
            if(fieldsIsValids[i] === false) {
              this.disabledSubmit = true
              return 0
            }
          }
          this.disabledSubmit = false
        },
        onSelectedProduct (product) {
          this.selectedProduct = product
        },

        getDataForCreate() {
          let data = {
            'client': this.quotation.contractor,
            'document_code': this.quotation.ruc,
            'is_partnership': this.quotation.partnership,
            'comment': this.quotation.comment,
            'turn_id': this.quotation.turn === null || this.quotation.turn.length>0 ? this.idOtros : this.quotation.turn.id,
            'turn_description': this.quotation.description ,
            'activity': this.quotation.activity,
            'values': [],
            'broker_id': this.quotation.broker
          }
          
          let counter = 0
          this.formProductsToShow.forEach((product) => {
            const productId = product.id
            product.fields.forEach((field) => {
              let value = {
                'product_id': productId,
                'field_id': field.id
              }
              
              if(field.field_type == 'select') {
                value['choice_id'] = field.choice_id
              }

              if(field.field_type == 'technical') {
                value['value'] = "-"
              }

              if(field.field_type == 'radio') {
                value['choice_id'] = field.choice_id
              }
              if (field.field_type == 'multifile') {
                const arrayFilesByProduct = []
                store.state.uploadFiles.forEach(uploadFile => {
                  if(productId === uploadFile.productId) {
                    arrayFilesByProduct.push(uploadFile.id)
                  }
                })
                value['attachment_ids'] = arrayFilesByProduct
                counter++
              } else if (field.field_type == 'toggle') {
                value['value'] = false
              } else if (field.field_type == 'switch') {
                value['value'] = field.value
              } else if (field.field_type == 'rate') {
                value['value'] = field.value
              } else if (field.field_type === 'money') {
                value['value'] = `${field.currency} ${field.value}`
              } else if (field.field_type === 'money2') {
                value['money_value'] = field.money_value
                value['money_value_currency'] = field.money_value_currency
              } else {
                  value['value'] = field.value
              }
              data.values.push(value)
            })
            
          })

          //Files para el programa estrategico clone
          let array_file_clone = []
          store.state.uploadFiles.forEach(uploadFile => {
            if(this.idProgramaEstrategicoCopy === uploadFile.productId) {
              array_file_clone.push(uploadFile.id)
            }
          })

          this.formProductsToShow.forEach((product) => {
            if(product.name == PROGRAMA_ESTRATEGICO){            
              
              //Array programa estrategico
              let ArrayProgramaEstrategico = []
              //Array programa estrategico Copy
              let ArrayProgramaEstrategicoCopy = []
              //Array de programa estrategico generado
              let dataProgramaEstrategicoCopy = []
              //Object Field de programa estrategico generado
              let fieldProgramaEstrageicoCopy= {}

              this.productsList.forEach(product =>{
                //Obtener el array de ambos ramos
                //Programa estrategico copy
                if(product.id == this.idProgramaEstrategicoCopy){
                  ArrayProgramaEstrategicoCopy.push(product)
                }
                //Programa estrategico
                if(product.id == this.idProgramaEstrategico) {
                  ArrayProgramaEstrategico.push(product)
                }
              })

              //Obtener el value de el programa estrategico
              let programa_money = ArrayProgramaEstrategico[0].fields.find((field) => field.field_type === "money");
              let programa_radio = ArrayProgramaEstrategicoCopy[0].fields.find((field) => field.field_type === "radio");
              let programa_switch = ArrayProgramaEstrategico[0].fields.find((field) => field.field_type === "switch");
              let programa_rate = ArrayProgramaEstrategico[0].fields.find((field) => field.field_type === "rate");
              
              //Recorrer el array del programa estrategico copia para armar el objeto y reemplazar los values
              ArrayProgramaEstrategicoCopy[0].fields.forEach(fieldClone =>{
                if(fieldClone.field_type == "multifile"){
                  fieldProgramaEstrageicoCopy = {"product_id":this.idProgramaEstrategicoCopy,"field_id":fieldClone.id,"attachment_ids": array_file_clone}
                }else if(fieldClone.field_type == "money"){
                  fieldProgramaEstrageicoCopy = {"product_id":this.idProgramaEstrategicoCopy,"field_id":fieldClone.id,"value": programa_money.currency + " " + programa_money.value}
                }else if(fieldClone.field_type == "radio"){
                  fieldProgramaEstrageicoCopy = {"product_id":this.idProgramaEstrategicoCopy,"field_id":fieldClone.id,"choice_id": programa_radio.choices[0].id,"value": programa_radio.choices[0].id}
                }else if(fieldClone.field_type == "switch"){
                  fieldProgramaEstrageicoCopy = {"product_id":this.idProgramaEstrategicoCopy,"field_id":fieldClone.id,"value":programa_switch.value}
                }else if(fieldClone.field_type == "rate"){
                  fieldProgramaEstrageicoCopy = {"product_id": this.idProgramaEstrategicoCopy, "field_id": fieldClone.id, "value": programa_rate.value}
                }              
                dataProgramaEstrategicoCopy.push(fieldProgramaEstrageicoCopy)
              })

            //Pushear la data del programa copy con las modificaciones
            data.values.push(...dataProgramaEstrategicoCopy)
            }
          })
          
          return data;
        },


        createQuotation () {
         
          this.createRequestIsLoading = true;

          let dataDerive = {
            action: "derive",
            attachment_ids: [],
            is_quotation: false,
            is_strategic: false,
            text: "Cotización enviada"
          }

          const self = this;
          const loader = this.$buefy.loading.open();
          return new Promise((resolve, reject) => {
          createQuotation(this.getDataForCreate()).then((response) => {
            resolve(response);
            if (response.status == 200) {
              response.data.quotations.forEach((quo)=>{
                let dataDeriveCustom = {
                  action: "derive",
                  attachment_ids: [],
                  is_quotation: false,
                  is_strategic: false,
                  text: "Cotización enviada"
                }
                //Soat & Vehicular
                if(quo.name === SOAT || quo.name == VEHICULAR){
                  quo.values.forEach(q =>{
                    if(q.field_type == "technical"){
                      dataDeriveCustom["technical_assignee"] = q.value;
                    }
                    if(q.field_type == "switch" && q.value == "True"){
                      updateProductData(quo.id, dataDeriveCustom)
                      .then(response =>{})
                    }
                  })
                // Programa estrategico
                }else if(quo.name === PROGRAMA_ESTRATEGICO){
                  dataDeriveCustom["technical_assignee"] = this.idBagResp3dDeshRoboTechnical;
                  quo.values.forEach(q =>{
                    if(q.field_type == "switch" && q.value == "True"){
                      updateProductData(quo.id, dataDeriveCustom)
                      .then(response =>{})
                    }
                  })
                // Programa estrategico copy
                }else if(quo.name === PROGRAMA_ESTRATEGICO_COPY){
                  dataDeriveCustom["technical_assignee"] = this.idBagMultiIncTechnical;
                  quo.values.forEach(q =>{
                    if(q.field_type == "switch" && q.value == "True"){
                      updateProductData(quo.id, dataDeriveCustom)
                      .then(response =>{})
                    }
                  })
                // Else
                }else{
                  quo.values.forEach(q =>{
                  if(q.field_type == "switch" && q.value == "True"){
                    updateProductData(quo.id, dataDerive)
                    .then(response =>{})
                  }
                  })
                }
              
              })
                this.$store.commit("deleteAllUploadCommentFiles");
                loader.close()
                self.$router.push({name:'QuotationCreated', params: {id: response.data.code }})
            }

          }
          
          ).catch((error) => {
              reject(error);
              this.$modal.show('modal-error-service');
              this.$store.commit("deleteAllUploadCommentFiles");
              loader.close()
              this.createRequestIsLoading = false;
              this.$store.commit("changeUpdateFetchCreate");
          });
        });
    
        },

        createQuotationsGroup() {
          this.createQuotation()
        },

        onSubmit (e) {
          e.preventDefault()
          this.createQuotationsGroup()
        },
  
        getTotalFiles: (fields) => {
          return fields.filter(f => f.field_type == 'file' && f.value).length
        },
  
        showFileName (name) {
          return SiteConfig.showFileName(name, 15, 8)
        },
  
        parseFieldValue(field) {
          if (field.field_type == 'toggle') {
            return ( field.value == true ) ? 'si':'no'
          }
          else if (field.field_type == 'switch') {
            return ( field.value == true ) ? 'A Técnica':'Mi bandeja'
          }
          else
            return field.value
        },
  
        handleProductButton(nameProduct) {
          this.activeProductButton[nameProduct] = !this.activeProductButton[nameProduct]
          const listProductToShowName = []
          if(this.activeProductButton[nameProduct] === false) {
            this.productsList.forEach( product => {
              if (product.name === nameProduct) {
                product.fields.forEach( field => {
                  if(field.field_type === 'multifile') {
                    field["isValid"] = false
                  }
                })
              }
            })
          }
          for (const buttonProductName in this.activeProductButton) {
            if(this.activeProductButton[buttonProductName]) {
              listProductToShowName.push(buttonProductName)
            }
          }
          const arrayProductToShow = []
          this.productsList.forEach( product => {
            listProductToShowName.forEach( productName => {
                if(product.name === productName) {
                  arrayProductToShow.push(product)
                }

            })
          })
          this.formProductsToShow = arrayProductToShow  
          const updateUploadFiles = []
          this.formProductsToShow.forEach( formProduct => {
            store.state.uploadFiles.forEach( uploadFile => {
              if(formProduct.id === uploadFile.productId ) {
                updateUploadFiles.push(uploadFile)
              }
              if(this.idProgramaEstrategicoCopy  === uploadFile.productId ) {
                updateUploadFiles.push(uploadFile)
              }
            })
          })

          this.$store.commit("setFormsProducts", this.formProductsToShow );
          this.$store.commit("updateUploadFiles", updateUploadFiles )
          nameProduct == MULTIRIESGO ? this.activityValidations() : null
          this.validateForm()

  
        },
        addStyle(nameProduct) {
          return this.activeProductButton[nameProduct]
        }
      }
  }
  </script>

  

  <style lang="scss">
  @import "../assets/scss/variables.scss";
    .title {
      font-weight: bold;
      font-size: 32px;
      font-family: 'mirairegular';
    }
    .phrase {
      font-weight: bold;
    }
    .phrase-wrapper {
      display: flex;
      font-size: 18px;
    }
    .tyc {
        margin: 1em 0;
    }
    .comment-wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-bottom: 20px;
        padding: 0 10px;
    }
    .autocomplete {
        .control {
            .input {
                box-shadow: none;
                border: 1px solid #e8e8e8;
                border-radius: 5px;
                height: 40px;
                padding: 10px;
                font-size: 14px;
                &:focus {
                    box-shadow: none;
                }
            }
        }
    }
    .business {
        opacity: 0;
        height: 0px;
    }
    .error-label {
      color: $primary;
      font-weight: 600;
    }
    .product-buttons-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
    .button-product {
      margin-bottom: 24px;
      margin-right: 8px;
    }
    .strategic-label-wrapper {
      background: #FFE4B3;
      box-shadow: 0px 2px 4px rgba(135, 135, 135, 0.3);
      border-radius: 5px;
      height: 38px;
      display: flex;
      flex-direction: initial;
      /* justify-content: center; */
      margin-left: 10px;
      padding-top: 6px;
    }
    .icon-strategic-wrapper {
      margin-top: 6px;
      margin-right: 6px;
    }
    .strategic-label {
      color: #C46800;
      font-size: 16px;
    }
    .icon-strategic {
      height: 15px;
      width: 15px;
    }
    .select {
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      padding: 5px;
      height: 50px !important;
    }
    .quotation-giro-wrapper{
      position: relative;
    }
    .quotation-giro-icon-search{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 20px;
      z-index: 10;
      pointer-events: none;
    }
    .autocomplete-new-quotation input{
      padding-left: 50px !important;
      box-sizing: border-box;
    }
    .quotation-giro-error{
      color: #EA5C6A;
      margin-top: 3px;
    }
  
    .quotation-giro-error-alfnum{
      color: #EA5C6A;
    }
  </style>
  